import React, { Component } from 'react';

import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';

class LoadingPgTemplate extends Component {
    state = {  }
    render() { 
        return (  
            <div className="loading_template_pg_icon_format">
                <ProgressSpinner 
                    className=" "
                    mode="indeterminate" 
                    style={{ height: '50px' }}>
                </ProgressSpinner>
            </div>
        );
    }
}
 
export default LoadingPgTemplate;